import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { async } from "widgets-for-react";
import { BlockRenderer } from "../../../components/block_renderer";
import { Jumbo } from "../../../components/jumbo";
import { loadLocation, loadMeans } from "./LocationOptionForm/LocationOptionFormApi";
import { LocationOptionForm } from "./LocationOptionForm/LocationOptionFormLayout";
export class LocationPage extends React.Component {
    componentDidMount() {
        document.title = this.props.pageTitle;
    }
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                async()(this.state.means).run((meansUpdater)=>this.setState((oldState)=>({
                            ...oldState,
                            means: meansUpdater(oldState.means)
                        }))),
                async()(this.state.location).run((locationUpdater)=>this.setState((oldState)=>({
                            ...oldState,
                            location: locationUpdater(oldState.location)
                        }))),
                /*#__PURE__*/ _jsxs("div", {
                    className: "location-page",
                    children: [
                        /*#__PURE__*/ _jsx(Jumbo, {
                            title: p.headerTitle,
                            contents: p.description,
                            imageUrlSmall: p.jumboSize == 'small' && p.phImageUrlSmall ? p.phImageUrlSmall : undefined,
                            imageUrl: p.phImageUrl,
                            imageUrlFallback: p.phImageUrlFallback,
                            imageUrlLarge: p.phImageUrlLarge,
                            imageAlt: p.imageAlt,
                            buttonUrl: p.buttonUrl,
                            buttonTitle: p.buttonTitle,
                            size: p.jumboSize
                        }),
                        /*#__PURE__*/ _jsx(BlockRenderer, {
                            blocks: p.blocks_upper
                        }),
                        /*#__PURE__*/ _jsx(LocationOptionForm, {
                            locationId: p.locationId,
                            location: this.state.location,
                            means: this.state.means,
                            hideForm: p.hideForm
                        }),
                        /*#__PURE__*/ _jsx(BlockRenderer, {
                            blocks: p.blocks
                        })
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            location: loadLocation(props.locationId),
            means: loadMeans(props.locationId)
        };
    }
}
{}